import { render, staticRenderFns } from "./full.vue?vue&type=template&id=a1dc97a4&scoped=true&"
import script from "./full.vue?vue&type=script&lang=js&"
export * from "./full.vue?vue&type=script&lang=js&"
import style0 from "./full.vue?vue&type=style&index=0&id=a1dc97a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1dc97a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wd\\fin24\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1dc97a4')) {
      api.createRecord('a1dc97a4', component.options)
    } else {
      api.reload('a1dc97a4', component.options)
    }
    module.hot.accept("./full.vue?vue&type=template&id=a1dc97a4&scoped=true&", function () {
      api.rerender('a1dc97a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/full.vue"
export default component.exports